import { render, staticRenderFns } from "./CQuotationDetails.vue?vue&type=template&id=12bf6b96&scoped=true"
import script from "./CQuotationDetails.vue?vue&type=script&lang=ts"
export * from "./CQuotationDetails.vue?vue&type=script&lang=ts"
import style0 from "./CQuotationDetails.vue?vue&type=style&index=0&id=12bf6b96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bf6b96",
  null
  
)

export default component.exports